<template>
	<div class="userList column-me">
		<div class="card-view column-me">
			<div class="card-title">学员列表</div>
			<div class="row-me row-center">
				<div class="width300 demo-input-size">
					<el-input placeholder="手机号/姓名/昵称" style="width: 100%;" v-model="keyword" :prefix-icon="Search"></el-input>
				</div>
				<el-form-item label="年级"  class="margin-left30 margin-top20 width200">
					<el-select v-model="grade_id" placeholder="年级选择">
						<el-option
							v-for="item in greadoption" 
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="代理" v-if="acctype == 1" class="margin-left30 margin-top20 width300">
					<el-popover :width="480" placement="bottom-start"  trigger="focus">
						<template #reference>
							<el-input v-model="agent_secKeyword" @input="agentSystemSearchList()" :focus="agent_secTableBoxOpen" placeholder="代理名称/联系人/手机号"></el-input>
						</template>
						<el-table :data="agent_secData" v-loading="agent_secloading" v-model="agent_secTableBox" size="large" :highlight-current-row="true" @row-click="agent_secSelected">
							<el-table-column width="150" align="center" property="lecturer_name" label="代理名称" />
							<el-table-column width="150" align="center" property="username" label="联系人" />
							<el-table-column width="150" align="center" property="phone" label="手机号" />
						</el-table>
					</el-popover>
				</el-form-item>
				<el-form-item label="地区" v-if="acctype==3" class="margin-left30 margin-top20 width400">
					<el-cascader
						style="width: 350px;"
					    v-model="area_id_arr"
					    :options="regionOption"
						:props="{ checkStrictly: true }"
					    @change="studentAreaChange"></el-cascader>
				</el-form-item>
				<el-form-item label="督学" v-if="acctype == 1"  class="margin-left30 margin-top20 width300">
					<el-popover :width="350" placement="bottom-start"  trigger="focus">
						<template #reference>
							<el-input v-model="inspectorKeyword" @input="inspectorSystemSearchList()" :focus="inspectorTableBoxOpen" placeholder="姓名/手机号"></el-input>
						</template>
						<el-table :data="inspectorData" v-loading="inspectorloading" v-model="inspectorTableBox" size="large" :highlight-current-row="true" @row-click="inspectorSelected">
							<el-table-column width="150" align="center" property="real_name" label="督学" />
							<el-table-column width="150" align="center" property="phone" label="手机号" />
						</el-table>
					</el-popover>
				</el-form-item>
				<el-button class="margin-left20" type="primary" size="mini " @click="clickSearch" >搜索</el-button>
				<el-button size="mini " @click="clickClear" >重置</el-button>
				<el-button size="mini " v-if="acctype==1 || acctype==3" v-loading.fullscreen.lock="fullscreenLoading" @click="exportDataExcel()" type="danger">Excel导出</el-button>
			</div>
			<div class="column-me flex1 overflow-auto">
				<div class="flex1 overflow-auto">
					<el-table :data="tableData" border v-loading="loading" stripe="true" size="medium" style="width: 100%" height="100%">
						<el-table-column prop="getTcAgentUser" label="代理商" width="200" align="center" show-overflow-tooltip>
							<template #default="scope">
								<div class="startTimeBox" v-if="scope.row.getTcAgentUser">代理：{{scope.row.getTcAgentUser.lecturer_name}}</div>
								<div class="startTimeBox margin-top10" v-if="scope.row.getTcAgentUser">联系人：{{scope.row.getTcAgentUser.username}}</div>
								<div class="startTimeBox margin-top10" v-if="scope.row.getTcAgentUser">地区：{{scope.row.getTcAgentUser.region}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="getTcAdminUser" label="督学" width="200" align="center" show-overflow-tooltip>
							<template #default="scope">
								<div class="startTimeBox" v-if="scope.row.getTcAdminUser">督学：{{scope.row.getTcAdminUser.real_name}}</div>
								<div class="startTimeBox margin-top10" v-if="scope.row.getTcAdminUser">电话：{{scope.row.getTcAdminUser.phone}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="phone" label="手机号码" width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="nickname" label="昵称" width="120" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="name" label="姓名" width="100" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="avatar" label="头像" width="80" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-image v-if="scope.row.avatar == null || scope.row.avatar == ''" class="avatarBox" :src="require('@/assets/images/user_avatar.png')"></el-image>
								<el-image v-else class="avatarBox" :src="scope.row.avatar"></el-image>
							</template>
						</el-table-column>
						<el-table-column prop="sex" label="性别" width="80" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="birthday" label="生日" width="120" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="grade_text" label="年级" width="80" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="getUserTags" label="学员标签" width="300" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-tag v-if="scope.row.getUserTags != null" v-for="(item,index) in scope.row.getUserTags" :key="index" type="danger" effect="dark">
								    {{ item.tag_text }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="signature" label="签名" width="300" align="center" show-overflow-tooltip></el-table-column>
						
						<el-table-column prop="ageText" label="年龄" width="80" align="center" show-overflow-tooltip>
							<template #default="scope">
								{{scope.row.ageText}}岁
							</template>
						</el-table-column>
						<el-table-column prop="area_text" label="地区" width="200" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="last_time" label="最后登陆时间" width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column label="操作" align="center" width="200" show-overflow-tooltip fixed="right">
							<template #default="scope">
								<div class="row-me center-all">
									<el-button type="success" size="small" @click="studentSpecialPage(scope.row.id)" >已开课程</el-button>
									<el-button type="danger" size="small" @click="studentStudyRecord(scope.row.id)" >学习记录</el-button>
								</div>
								<div v-if="acctype != 3" class="row-me center-all margin-top10">
									<el-button type="warning" size="small" @click="drawerBoxOpen(scope.row)">标签编辑</el-button>
									<el-button  v-if="acctype < 3" type="primary" size="small" @click="traineeTransferOpen(scope.row)" >学员转移</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="margin-top20">
					<el-pagination @current-change="handleCurrentChange" background :current-page.sync="pageNo"
                         layout="total, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
	<!-- 课程素材学习进度调整 -->
	<el-dialog title="学员转移" v-model="traineeTransferState" width="1500px" top="5vh" :destroy-on-close="true">
	    <div class="userList column-me">
			<el-divider content-position="left">学员基础信息</el-divider>
			<div class="row-me row-center">
				<el-descriptions  style="width: 100%;" size="small" :column = "4" border>
					<el-descriptions-item label="头像">
						<el-image v-if="dataInfo.avatar == null" class="avatarBox" :src="require('@/assets/images/user_avatar.png')"></el-image>
						<el-image v-else class="avatarBox" :src="dataInfo.avatar"></el-image>
					</el-descriptions-item>
					<el-descriptions-item label="姓名">{{dataInfo.name}} </el-descriptions-item>
					<el-descriptions-item label="性别">{{dataInfo.sex}}</el-descriptions-item>
					<el-descriptions-item label="年龄">{{dataInfo.ageText}}岁</el-descriptions-item>
					
					<el-descriptions-item label="生日">{{dataInfo.birthday}}</el-descriptions-item>
					<el-descriptions-item label="手机号">{{dataInfo.phone}}</el-descriptions-item>
					<el-descriptions-item label="昵称">{{dataInfo.nickname}}</el-descriptions-item>
					<el-descriptions-item label="年级">{{dataInfo.grade_text}}</el-descriptions-item>
					
					<el-descriptions-item label="地区">{{dataInfo.area_text}}</el-descriptions-item>
					<el-descriptions-item label="签名">{{dataInfo.signature}}</el-descriptions-item>
				</el-descriptions>			
			</div>
			<el-divider content-position="left">学员当前（代理信息）</el-divider>
			<div class="row-me row-center">
				<el-descriptions  style="width: 100%;" size="small" :column = "4" border>
					<el-descriptions-item label="代理名称">{{dataInfo.getTcAgentUser.lecturer_name}}</el-descriptions-item>
					<el-descriptions-item label="联系人">{{dataInfo.getTcAgentUser.username}}</el-descriptions-item>
					<el-descriptions-item label="地区">{{dataInfo.getTcAgentUser.region}}</el-descriptions-item>
				</el-descriptions>
			</div>
			<el-divider content-position="left">选择转移目标（代理信息）</el-divider>
			<div class="row-me row-center">
				<div class="width300 demo-input-size">
					<el-input placeholder="代理名称/联系人/电话"  style="width: 100%;" v-model="agentKeywords" :prefix-icon="Search"></el-input>
				</div>
				<el-form-item label="地区"  class="margin-left30 margin-top20 width400">
					<el-cascader
						style="width: 350px;"
					    v-model="agentArea_id"
					    :options="regionOption"
						:props="{ checkStrictly: true }"
					    @change="agentAreaChange"></el-cascader>
				</el-form-item>
				<el-button class="margin-left20" type="primary" size="mini " @click="agentClickSearch" >搜索</el-button>
				<el-button size="mini " @click="agentclickClear" >重置</el-button>
			</div>
			<div class="row-me row-center">
				<el-table 
					:data="agentData" 
					border 
					v-loading="loading" 
					highlight-current-row 
					stripe="true"
					size="small" 
					style="width: 100%" 
					height="240px">
					<el-table-column prop="radio" label="" width="45" align="center" show-overflow-tooltip>
						 <template #default="scope">
						 	<el-radio :value="scope.row.id" v-model="agentCurrentRow" @change="handleAgentRadioChange(scope.row.id)"></el-radio>
						 </template>
					</el-table-column>
					<el-table-column prop="lecturer_name" label="代理商" align="center" show-overflow-tooltip></el-table-column>
					<el-table-column prop="username" label="联系人" align="center" show-overflow-tooltip></el-table-column>
					<el-table-column prop="phone" label="电话" align="center" show-overflow-tooltip></el-table-column>
					<el-table-column prop="regionText" label="地区" align="center" show-overflow-tooltip></el-table-column>
					<el-table-column prop="study_num" label="学生数量" width="200" align="center" show-overflow-tooltip></el-table-column>
				</el-table>
				
			</div>
			<div class="row-me row-center margin-top20" style="text-align: right;">
				<el-pagination @current-change="handleAgentCurrentChange" background :current-page.sync="agentPageNo"
				     layout="total, prev, pager, next, jumper" :total="agentTotal">
				</el-pagination>
			</div>
			<div class="row-me flex-end1 margin-top20">
				<el-button @click="traineeTransferClosed()">取消</el-button>
				<el-button @click="traineeTransferPost()" type="primary">保存</el-button>
			</div>
		</div>
	</el-dialog>
	<!-- 课程素材学习进度调整 -->
	<el-drawer
		v-model="drawerStatue"
		:resizable="true"
		:show-close="false"
		size="40%">
		<div class="row-me row-center" v-if="drawerStudent != null">
				<el-descriptions title="学员基础信息" colon="true" style="width: 100%;" :column = "2" border>
					<el-descriptions-item label="头像">
						<el-image v-if="drawerStudent.avatar == null" class="avatarBox" :src="require('@/assets/images/user_avatar.png')"></el-image>
						<el-image v-else class="avatarBox" :src="drawerStudent.avatar"></el-image>
					</el-descriptions-item>
				  	<el-descriptions-item label="生日">{{drawerStudent.birthday}}</el-descriptions-item>
				  	<el-descriptions-item label="性别">{{drawerStudent.sex}}</el-descriptions-item>
				  	<el-descriptions-item label="年龄">{{drawerStudent.ageText}}岁</el-descriptions-item>
					
					<el-descriptions-item label="姓名">{{drawerStudent.name}} </el-descriptions-item>
					<el-descriptions-item label="手机号">{{drawerStudent.phone}}</el-descriptions-item>
					
					<el-descriptions-item label="昵称">{{drawerStudent.nickname}}</el-descriptions-item>
					<el-descriptions-item label="年级">{{drawerStudent.grade_text}}</el-descriptions-item>
					<el-descriptions-item label="地区">{{drawerStudent.area_text}}</el-descriptions-item>
					<el-descriptions-item label="签名">{{drawerStudent.signature}}</el-descriptions-item>
					<el-descriptions-item label="学员标签">
						<el-tag size="medium" :key="index" type="danger" effect="dark" v-for="(item,index) in dynamicTags" closable :disable-transitions="false" @close="handleClose(item.user_id,item.tag_text,index)">{{item.tag_text}}</el-tag>
						<el-input 
							class="input-new-tag" 
							v-if="inputVisible" 
							v-model="inputValue"
							ref="saveTagInput"
							@keyup.enter.native="handleInputConfirm"
							@blur="handleInputConfirm"
						>
						</el-input>
						<el-button v-else class="button-new-tag" @click="showInputTags">+ 新增</el-button>
					</el-descriptions-item>
				</el-descriptions>
		</div>
	</el-drawer>
</template>
<script>
import {Plus,Search} from "@element-plus/icons";
import { regionOption } from '../../assets/js/citys.js';
export default {
  components: {Plus,Search,regionOption},
  data() {
    return {
		acctype:null,
		fullscreenLoading: false,
		acctype:null,
		keyword: '',
		pageNo: 1,
		total: 0,
		area_id_arr:'',
		area_id:0,
		loading:false,
		tableData:[],

		traineeTransferState:false,		//学院转移弹窗状态
		greadoption:[
			{
				value:1,
				label:'高中'
			},{
				value:2,
				label:'初中'
			}
		],
		grade_id:null,
		regionOption:null,
		dataInfo:null,
		//代理商选择
		agentData:[],
		agentArea_id:'',
		agentKeywords:'',
		area_id_arr:'',
		area_id:0,
		agentPageNo:1,
		agentTotal: 0,
		agentCurrentRow:null,
		agentSelectedId:'',
		agentStudentId:'',
		oldAgentId:'',
		agentType:'',
		//抽屉
		drawerStatue:false,
		drawerDirection:'rt1',
		drawerStudent:null,
		dynamicTags:[
			
		],
		inputVisible:false,
		inputValue:'',
		
		//代理商输入框弹窗table表格检索
		agent_sec_id:0,
		agent_secKeyword:'',
		agent_secData:null,
		agent_secTableBox:false,
		agent_secloading:false,
		//督学输入框弹窗table表格检索
		inspector_id:0,
		inspectorKeyword:'',
		inspectorData:null,
		inspectorTableBox:false,
		inspectorloading:false,
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {
    Search() {
      return Search
    }
  },
	// html加载完成之前
	created() {
		this.acctype = sessionStorage.getItem('acctype');
		console.log(this.acctype);
		this.clickSearch()
		this.agentClickSearch()
		this.agentSystemSearchList()
		this.inspectorSystemSearchList()
	},
  // html加载完成后执行。
  mounted() {
	this.regionOption = regionOption;
  },
  // 事件方法执行
  methods: {
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    clickClear() {
      this.keyword = '';
      this.area_id_arr = '';
	  this.area_id = null;
	  this.grade_id = null;
	  this.agent_sec_id = 0;
	  this.agent_secKeyword = '';
	  this.agent_secTableBox = false;
	  this.inspector_id = 0;
	  this.inspectorKeyword = '';
	  this.inspectorTableBox = false;
      this.clickSearch();
	  this.agentSystemSearchList()
	  this.inspectorSystemSearchList()
    },
	//列表分页
	handleCurrentChange(pageNo) {
	    this.pageNo = pageNo
	    this.getData()
	},
	//地区选择
	studentAreaChange(value){
		this.area_id_arr = value;
		if(this.area_id_arr.length == 1){
			this.area_id = this.area_id_arr[0]; 
		}else if(this.area_id_arr.length == 2){
			this.area_id = this.area_id_arr[1]; 
		}else if(this.area_id_arr.length == 3){
			this.area_id = this.area_id_arr[2]; 
		}
		console.log(this.area_id);
	},
	
    //table获取数据
    getData() {
		this.loading = true;
		var data = {
			keyword: this.keyword,
			grade_id:this.grade_id,
			agent_id:this.agent_sec_id,
			admin_id:this.inspector_id,
			page: this.pageNo
		};
		console.log(data);
		this.$post('/admin/studentList', data).then((res) => {
			if (res) {
				console.log(res.data);
				this.total = res.data.all_info_num
				this.tableData = res.data.listInfo
				this.loading = false;
			}
		}).catch((error) => {
			console.log(error)
		})
    },
	
	//table数据 Excel 导出
	exportDataExcel() {
		this.fullscreenLoading = true;
		this.$post('/admin/greatStudentExcel', {
			keyword: this.keyword,
			grade_id:this.grade_id,
			area_id:this.area_id,
		}).then((res) => {
			console.log(res);
			this.downloadFile(res.data);
			this.fullscreenLoading = false;
		}).catch((error) => {
			console.log(error)
		})
	},
	//模拟a标签下载
	downloadFile(fileslink) {
	      const link = document.createElement('a');
		  link.target = '_blank';
	      link.href = fileslink;
	      link.download = '学生信息表.xlsx';
	      link.style.display = 'none';
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	},
	//跳转学院已开课程列表页
	studentSpecialPage(obj=0){
		this.$router.push({
			name:'studentSpecialList',
			query:{
				id:obj
			}
		})
	},
	//跳转学习记录页面
	studentStudyRecord(obj=0){
		this.$router.push({
			name:'studentStudyRecord',
			query:{
				user_id:obj
			}
		})
	},
	//学员转移弹窗打开
	traineeTransferOpen(obj){
		if(obj.getTcAgentUser==null){
			this.$message.warning('该学员还未绑定代理商，无法转移！')
			return;
		}
		this.dataInfo = obj;
		this.agentStudentId = obj.id;
		this.oldAgentId = obj.getTcAgentUser.id;
		this.agentType = obj.getTcAgentUser.id;
		this.traineeTransferState = true;
		//console.log(obj);
	},
	//学员转移弹窗关闭
	traineeTransferClosed(){
		this.traineeTransferState = false;
	},
	//学员转移保存
	traineeTransferPost(){
		const dataInfo = {
			student_id:this.agentStudentId,
			agent_id:this.agentSelectedId,
			olderAgent_id:this.oldAgentId,
			agent_type:this.agentType,
		}
		this.$post('/admin/editStudentAgent', dataInfo).then((res) => {
			if (res) {
				this.$message.success('保存成功')
				this.getData();
				this.traineeTransferState = false;
			}
		}).catch((error) => {
			console.log(error)
		})
		//console.log(dataInfo);
	},
	//代理商地区选择
	agentAreaChange(value){
		if(value.length == 1){
			this.agentArea_id = value[0]; 
		}else if(value.length == 2){
			this.agentArea_id = value[1]; 
		}else if(value.length == 3){
			this.agentArea_id = value[2]; 
		}
	},
	agentClickSearch() {
	  this.agentPageNo = 1
	  this.getAgentListInfo()
	},
	agentclickClear(){
		this.agentKeywords = '';
		this.agentArea_id = '';
		this.getAgentListInfo();
	},
	//列表分页
	handleAgentCurrentChange(pageNo) {
	    this.agentPageNo = pageNo
	    this.getAgentListInfo()
	},
	//获取代理商信息
	getAgentListInfo(){
		this.$post('/admin/agentInfoList', {
			keyword: this.agentKeywords,
			area_id:this.agentArea_id,
			status:1,
			page: this.agentPageNo
		}).then((res) => {
			if (res) {
				this.agentTotal = res.data.all_info_num
				this.agentData = res.data.listInfo
				this.loading = false;
			}
		}).catch((error) => {
			console.log(error)
		})
	},
	//选中代理商信息
	handleAgentRadioChange(obj){
		this.agentSelectedId = obj;
	},
	//学员标签
	drawerBoxOpen(obj){
		this.drawerStatue = true;
		this.drawerStudent = obj;
		this.dynamicTags = obj.getUserTags;
	},
	drawerBoxClose(done){
		
	},
	handleClose(user_id,tag,index) {
		const data = {
			user_id:user_id,
			tag_text:tag
		};
		this.dynamicTags.splice(this.dynamicTags.findIndex(item=>item.tag_text===tag), 1);
		this.$post('/admin/tcUserTagsDel', data).then((res) => {
			console.log(res);
		}).catch((error) => {
			console.log(error)
		})
	},
	showInputTags() {
	    this.inputVisible = true;
	    this.$nextTick(_ => {
	        this.$refs.saveTagInput.$refs.input.focus();
	    });
	},
	handleInputConfirm() {
	    let inputValue = this.inputValue;
	    if (inputValue) {
			this.dynamicTags.push({
				user_id:this.drawerStudent.id,
				tag_text:inputValue
			})
			this.postUserTagsInfoSave(inputValue);
	    }
	    this.inputVisible = false;
	    this.inputValue = '';
	},
	//标签信息提交保存
	postUserTagsInfoSave(value){
		const data = {
			user_id:this.drawerStudent.id,
			tag_text:value
		};
		// console.log(data);
		// return;
		this.$post('/admin/tcUserTagsAdd', data).then((res) => {
			
		}).catch((error) => {
			console.log(error)
		})
	},
	//==================================代理检索======================================
	//代理检索table数据
	agentSystemSearchList(){
		console.log(this.agent_secKeyword);
		this.agent_secloading = true;
		if(this.agent_secKeyword == null){
			this.agent_secKeyword = '';
		}
		
		this.$post('/admin/agentSystemSearchList', {
			keyword: this.agent_secKeyword,
		}).then((res) => {
			if (res) {
				console.log(res.data);
				this.agent_secData = res.data;
				this.agent_secloading = false;
			}
		}).catch((error) => {
			console.log(error)
		})
	},
	//代理检索选中
	agent_secSelected(row){
		//console.log(row);
		this.agent_secKeyword = row.lecturer_name;
		this.agent_sec_id = row.id;
		this.agent_secTableBox = false;
		
		//console.log(this.agent_sec_id);
		this.getData();
	},
	agent_secTableBoxOpen(){
		this.agent_secTableBox = true;
	},
	//==================================督学检索======================================
	//代理检索table数据
	inspectorSystemSearchList(){
		this.inspectorloading = true;
		if(this.inspectorKeyword == null){
			this.inspectorKeyword = '';
		}
		
		this.$post('/admin/inspectorSystemSearchList', {
			keyword: this.inspectorKeyword,
		}).then((res) => {
			if (res) {
				console.log(res.data);
				this.inspectorData = res.data;
				this.inspectorloading = false;
			}
		}).catch((error) => {
			console.log(error)
		})
	},
	//代理检索选中
	inspectorSelected(row){
		//console.log(row);
		this.inspectorKeyword = row.real_name;
		this.inspector_id = row.id;
		this.inspectorTableBox = false;
		
		//console.log(this.agent_sec_id);
		this.getData();
	},
	inspectorTableBoxOpen(){
		this.inspectorTableBox = true;
	},
  },
}
</script>

<style lang="scss" scoped>
	.floatR{
		float: right;
	}
	.el-drawer {
	  z-index: 2000 !important; /* 根据需要调整 */
	}
	.avatarBox{
		width: 40px;
		height: 40px;
		border-radius: 20px;
		overflow: hidden;
	}
	.startTimeBox{
		float: left;
		width: 100%;
		height: 20px;
		text-align: left;
		line-height: 20px;
		font-size: 14px;
		color: #555555;
		// background-color: aquamarine;
	}
	.areaBox{
		width: 400px;
	}
	.el-tag + .el-tag {
	    margin-left: 10px;
	  }
	  .button-new-tag {
	    margin-left: 10px;
	    height: 32px;
	    line-height: 30px;
	    padding-top: 0;
	    padding-bottom: 0;
	  }
	  .input-new-tag {
	    width: 90px;
	    margin-left: 10px;
	    vertical-align: bottom;
	  }
.userList {
  height: 100%;

  .img-header {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  
	
}
</style>
